import { API } from "aws-amplify";
import { API_NAME } from "../common/constants";

export const getMailTemplate = async (templateKey: string) => {
  const path = `/mail-templates/${encodeURIComponent(templateKey)}`;
  const params = {};
  let result: any;
  await API.get(API_NAME, path, params)
    .then((response) => {
      result = response;
    })
    .catch((e) => {
      console.error(e);
      result = e.response.data;
    });
  return result;
};
